import { combineSlices, compose, configureStore } from '@reduxjs/toolkit';
import persistState from 'redux-sessionstorage';

import socketMiddleware from 'services/socketMiddleware';
import { announcementApi } from 'store/api/announcementApi';
import { referenceApi } from 'store/api/referenceApi';
import { authSlice } from 'store/auth/authSlice';
import { gridsSlice } from 'store/grids/gridsSlice';
import { notificationSlice } from 'store/notification/notificationSlice';
import { clientSlice } from 'store/referralForm/clientSlice';
import { questionSlice } from 'store/referralForm/questionSlice';
import { referenceSlice } from 'store/referralForm/referenceSlice';
import { referralFormSlice } from 'store/referralForm/referralFormSlice';
import { referralHistorySlice } from 'store/referralHistory/referralHistorySlice';

const sessionStorageEnhancer = compose(
    persistState([referralFormSlice.name, gridsSlice.name], { key: 'rtaStore' }),
);

const slices = [
    authSlice,
    clientSlice,
    gridsSlice,
    notificationSlice,
    questionSlice,
    referenceSlice,
    referralFormSlice,
    referralHistorySlice,
];

const apiSlices = [announcementApi, referenceApi];

const rootReducer = combineSlices(...slices, ...apiSlices);

export const store = configureStore({
    reducer: rootReducer,
    middleware: (getDefaultMiddleware) =>
        getDefaultMiddleware({ serializableCheck: false }).concat(
            socketMiddleware,
            apiSlices.map((slice) => slice.middleware),
        ),
    enhancers: (getDefaultEnhancers) => getDefaultEnhancers().concat(sessionStorageEnhancer),
    devTools: process.env.REACT_APP_ENV !== 'prd',
});

/** Used for configuration of redux store in tests */
export const MockStore = {
    reducer: rootReducer,
    middleware: (getDefaultMiddleware) =>
        getDefaultMiddleware({ serializableCheck: false }).concat(
            socketMiddleware,
            apiSlices.map((slice) => slice.middleware),
        ),
};
